import React from "react"
// react component for creating dynamic tables
import ReactTable from "react-table"

import * as Alert from "alertService"
import { APIPost, APIGet } from "services/APIRequest"
import UrlServer from "configs/UrlServer"
import { ErrorsCallback, SuccessCallback, WarningCallback } from "alertService"
import { thaiBath } from "helpers/ConvertFormat"
import { ISOToDateYMDAndFullTime } from "helpers/ConvertDate"
import { arrayObject, arrayTypeKeyObject } from "helpers/ConvertKey"

import { compose } from "recompose"
import { connect } from "react-redux"
import { listsThemeSMSUpdate } from "store/actions"

import Lg from "language"
import ConfigHost from "services/ConfigHost"

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"
// @material-ui/icons
import FormatListNumberedIcon from "@material-ui/icons/FormatListNumbered";
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import DeleteIcon from '@material-ui/icons/Delete';
import SendIcon from '@material-ui/icons/Send';
import PreviewIcon from '@material-ui/icons/Visibility';

// core components 
import Autocomplete from "components/Autocomplete/Select.jsx";
import GridContainer from "components/Grid/GridContainer"
import GridItem from "components/Grid/GridItem"
import Button from "components/CustomButtons/Button"
import Card from "components/Card/Card"
import CardBody from "components/Card/CardBody"
import CardIcon from "components/Card/CardIcon"
import CardHeader from "components/Card/CardHeader"
import Select from "components/CustomSelects/Select"
import Switch from "@material-ui/core/Switch"
import Badge from "components/Badge/Badge"
import Tooltip from "@material-ui/core/Tooltip";

import { cardTitle } from "assets/jss/material-dashboard-pro-react"

import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle"
import tasksStyle from "assets/jss/material-dashboard-pro-react/components/tasksStyle";
import { URL_POST_POST_TELESURVEYHISTORY_GETCALLHISTORY } from "../../../configs/UrlServer"
const styles = {
  ...extendedFormsStyle,
  ...tasksStyle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  noConfirmedemail: {
    color: "red"
  },
  devType: {
    color: "#689F38"
  },
  tableH: {
    // marginTop: "30px",
    // marginBottom: "30px"
  }
}
class UserFromImportListManagement extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      currentPage: 0,
      statusWaitingUpdate: true,

      listsThemeSMS: [],
      listsThemeSMSRaw: [],
      selectListsThemeSMS: null,

      dataListRaw: [],
      dataList: [],
      selectDataList: null
    }
  }
  componentDidMount() {
    this.props.listsThemeSMSUpdate(true)
    // this.onDownloadListImport(() => {
    // })
  }
  componentWillUpdate(nextProps, nextState) {
    if (nextProps.listsThemeSMS && nextProps.listsThemeSMS !== nextState.listsThemeSMSRaw) {
      this.setState({
        listsThemeSMSRaw: nextProps.listsThemeSMS,
        listsThemeSMS: this.renderListData(nextProps.listsThemeSMS)
      }, () => {
        Alert.LoadingClose()
      })
    }
  }
  onDownloadListImport(callback) {
    Alert.Loading(true)
    const dataToSend = {
    }
    APIPost(UrlServer.URL_POST_SMS_DATA_IMPORT_LIST, dataToSend, (datas) => {
      var newConvertDatas = arrayObject(datas.datas, [
        {
          oldKey: "_id",
          newKey: "value"
        },
        {
          oldKey: "_id",
          newKey: "label"
        },
        {
          oldKey: "count",
          newKey: "count"
        },
        {
          oldKey: "created_date_iso",
          newKey: "created_date_iso"
        },
        {
          oldKey: "send_sms_date",
          newKey: "send_sms_date"
        },
      ]
      )
      var select_old = null
      newConvertDatas.map((row, index) => {
        newConvertDatas[index].label += " , ตั้งเวลาส่ง " + (newConvertDatas[index].send_sms_date ? ISOToDateYMDAndFullTime(newConvertDatas[index].send_sms_date) : "-") + " , ถูกสร้างเมื่อ " + ISOToDateYMDAndFullTime(newConvertDatas[index].created_date_iso)
        if (this.state.selectDataListImport != null) {
          if (row.value == this.state.selectDataListImport.value) {
            select_old = newConvertDatas[index]
          }
        }
      })
      this.setState({
        dataListImport: newConvertDatas,
        statusWaitingUpdate: false
      }, () => {
        Alert.LoadingClose()
        // if (select_old != null) {
        //   this.setState({
        //     statusWaitingUpdate: true,
        //   }, () => {
        //     this.setState({
        //       selectDataListImport: select_old,
        //       statusWaitingUpdate: false,
        //     }, () => {
        //       if (callback) callback()
        //     })
        //   })
        // } else {
        if (callback) callback()
        // }
      })
    })

  } 
  handleChangeActive = (id, name, status) => {
    Alert.QuestionCallback("คุณต้องการเปลี่ยนสถานะการใช้งานของ " + name + " เป็น " + status + " ใช่หรือไม่?", "blue", () => {
      const dataToSend = {
        _id: id,
        active: status
      }
      APIPost(UrlServer.URL_POST_THEME_SMS_ACTIVE, dataToSend, (datas) => {
        this.props.listsThemeSMSUpdate(true)
      })
    })
  }
  renderListData = data => {
    return data.map((CData, key) => {
      return {
        id: (key + 1),
        theme_name: CData.theme_name ? CData.theme_name : "-",
        message: CData.mobile_number ? CData.message : "-",
        txt_sms_message: CData.txt_sms_message ? CData.txt_sms_message + "" : "-",
        start_active_sms_date: CData.start_active_sms_date ? ISOToDateYMDAndFullTime(CData.start_active_sms_date) : "-",
        end_active_sms_date: CData.end_active_sms_date ? ISOToDateYMDAndFullTime(CData.end_active_sms_date) : "-",
        created_date_iso: CData.created_date_iso ? ISOToDateYMDAndFullTime(CData.created_date_iso) : "-",
        updated_date_iso: CData.updated_date_iso ? ISOToDateYMDAndFullTime(CData.updated_date_iso) : "-",
        active: (
          <div>
            <Switch
              checked={CData.active}
              onChange={e => {
                this.handleChangeActive(CData._id, CData.theme_name, !CData.active)
              }}
              classes={{
                switchBase: this.props.switchBase,
                checked: this.props.switchChecked,
                icon: this.props.switchIcon,
                iconChecked: this.props.switchIconChecked,
                bar: this.props.switchBar
              }}
            />
          </div>
        ),
        actions: (
          <div
            className="actions-right"
            key={"rows_"+key}
          >
            <Button
              size="sm"
              round
              color="danger"
              className={this.props.classes.mb4}
              onClick={e => this.handleDeleteData(CData)}
            >
              <DeleteIcon className={this.props.classes.icons} />
              {Lg.ts('ลบ')}
            </Button>{" "}
            <Button
              size="sm"
              round
              color="info"
              className={this.props.classes.mb4}
              onClick={e => this.handleEdit(CData)}
            >
              <PreviewIcon className={this.props.classes.icons} />
              {Lg.ts('ดูรายละเอียด / แก้ไข')}
            </Button>
          </div>
        ),
      }
    })
  }
  handleEdit = (CData, statusDeleteAll = false) => { 
    this.props.callbacksetTabIndex(1,CData) 
  }
  handleDeleteData = (CData, statusDeleteAll = false) => {

    Alert.WarningCallback("คุณต้องการลบ " + CData.theme_name + " ใช่หรือไม่?", () => {
      const dataToSend = {
        _id: CData._id,
      }
      APIPost(UrlServer.URL_POST_THEME_SMS_DELETE, dataToSend, (datas) => {
        SuccessCallback(datas.message, null, () => {
          this.props.listsThemeSMSUpdate(true)
        })
      })
    }, true)
  }
  render() {
    const { classes } = this.props
    return (
      <div className={"card-space"}>
        <GridContainer key="gc-1">
          <GridItem xs={12}>
            <Card >
              <CardHeader color="info" icon>
                <CardIcon color="info">
                  <FormatListNumberedIcon />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>{Lg.ts('รายการ SMS นำเข้าระบบโดยการ Import')}</h4>
              </CardHeader>
              <CardBody>
                <GridContainer key="gc-2">
                  <GridItem xs={12} >
                    {
                      !this.state.statusWaitingUpdate ?
                        <Autocomplete
                          handleChange={this.handleChangeAutoCompleteNormally}
                          value={this.state.selectDataListImport}
                          dataList={this.state.dataListImport}
                          id="selectDataListImport"
                          label={Lg.ts('เลือกชื่อรอบการ Import')} 
                        />
                        : null
                    }

                    <br />
                  </GridItem>
                </GridContainer>
                <ReactTable
                  className="-striped -highlight table-scroll"
                  data={this.state.listsThemeSMS}
                  filterable
                  columns={[
                    {
                      Header: "#",
                      accessor: "id",
                      width: 50
                    },
                    {
                      Header: Lg.ts("ตั้งค่าต่างๆ"),
                      accessor: "actions",
                      sortable: false,
                      filterable: false,
                      width: 260
                    },
                    {
                      Header: Lg.ts("เปิด/ปิด"),
                      accessor: "active",
                      sortable: false,
                      filterable: false,
                      width: 110
                    },
                    {
                      Header: Lg.ts("ชื่อธีม"),
                      accessor: "theme_name",
                      width: 130,
                      filterMethod: (filter, row) => {
                        return row.theme_name.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
                      }
                    },
                    {
                      Header: Lg.ts("ข้อความ"),
                      accessor: "txt_sms_message",
                      width: 330,
                      filterMethod: (filter, row) => {
                        return row.txt_sms_message.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
                      }
                    },
                    {
                      Header: Lg.ts("วันให้แสดง"),
                      accessor: "start_active_sms_date",
                      width: 160,
                      filterMethod: (filter, row) => {
                        return row.start_active_sms_date.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
                      }
                    },
                    {
                      Header: Lg.ts("วันปิดแสดง"),
                      accessor: "end_active_sms_date",
                      width: 160,
                      filterMethod: (filter, row) => {
                        return row.end_active_sms_date.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
                      }
                    },
                    {
                      Header: Lg.ts("วันที่สร้าง"),
                      accessor: "created_date_iso",
                      width: 160,
                      filterMethod: (filter, row) => {
                        return row.created_date_iso.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
                      }
                    },
                    {
                      Header: Lg.ts("วันอัปเดต"),
                      accessor: "updated_date_iso",
                      filterMethod: (filter, row) => {
                        return row.updated_date_iso.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
                      }
                    },
                    // {
                    //   Header: "ตั้งเวลาส่ง",
                    //   accessor: "send_sms_date",
                    //   sortable: false,
                    //   filterable: false,
                    //   filterMethod: (filter, row) => {
                    //     return row.send_sms_date.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
                    //   }
                    // },   
                  ]}
                  defaultPageSize={10}
                  showPaginationTop
                  showPaginationBottom={false}
                />
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div >
    )
  }
}

function mapStateToProps({ listsThemeSMS }) {
  return {
    listsThemeSMS: listsThemeSMS
  }
}

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    { listsThemeSMSUpdate }
  )
)(UserFromImportListManagement)
